var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          title:
            _vm.user.first_name +
            " " +
            _vm.user.last_name +
            " " +
            _vm.$t("pages.account.title"),
          "use-title-as-document-title": false,
          "icon-class": "mdi mdi-account"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-4" }, [
        _c("div", { staticClass: "col-md-3" }, [
          _c(
            "div",
            { staticClass: "list-group" },
            _vm._l(_vm.links, function(link) {
              return _c(
                "router-link",
                {
                  key: link.title,
                  staticClass:
                    "list-group-item d-flex justify-content-between align-items-center oswald text-primary",
                  class: {
                    active: _vm.isActive(link),
                    "text-danger":
                      link.icon === "mdi-heart" && _vm.healthProblem(link)
                  },
                  attrs: { tag: "a", to: link.route }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(link.title) +
                      "\n                    "
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "badge badge-primary badge-dark badge-pill",
                      class: {
                        "text-danger":
                          link.icon === "mdi-heart" && _vm.healthProblem(link)
                      }
                    },
                    [_c("i", { staticClass: "mdi mdi-18px", class: link.icon })]
                  )
                ]
              )
            }),
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-9" },
          [
            _c(
              "transition",
              { attrs: { name: "component-fade", mode: "out-in" } },
              [_c("router-view", { attrs: { user: _vm.user } })],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }